export default __webpack_public_path__ + "static/media/img-7.cf24abfb.png";